import axiosApi from "./api";

/**
 * 获取评委列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {string} params.userName - 评委姓名
 * @param {string} params.phone - 评委手机号
 * @returns {Promise} - 返回评委列表
 */
export function getJudgeList(params) {
  return axiosApi({
    url: "/tc/hosp/tbJudge/list",
    method: "get",
    params,
  });
}

/**
 * 评委扩展表-通过id查询
 * @param {number} id - 评委ID
 * @returns {Promise} - 返回评委扩展信息
 */
export function getJudgeDetail(id) {
  return axiosApi({
    url: `/tc/hosp/tbJudge/queryById`,
    method: "get",
    params: { id },
  });
}

/**
 * 评委扩展表-编辑
 * @param {Object} data - 评委扩展信息
 * @returns {Promise} - 返回编辑结果
 */
export function editJudge(data) {
  return axiosApi({
    url: "/tc/hosp/tbJudge/edit",
    method: "post",
    data,
  });
}

export function uploadFile(file) {
  return axiosApi({
    url: "/tc/hosp/file/upload",
    method: "post",
    data: {
      file,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 根据id获取终评数据
export function getFinalJudge(id) {
  return axiosApi({
    url: `/tc/hosp/tbScoreFinal/queryById`,
    method: "get",
    params: { id },
  });
}

// 编辑终评数据
export function editFinalJudge(data) {
  return axiosApi({
    url: "/tc/hosp/tbScoreFinal/edit",
    method: "post",
    data,
  });
}
